import React from 'react';
import { message } from 'antd';
import { Select, FormItem } from '@xbcb/form-item-components';
import { email as emailRegex } from '@xbcb/regex';
import { CssSize } from '@xbcb/ui-types';
import { FormInstance } from 'antd/lib/form';
import { safeGetMessage } from '@xbcb/ui-utils';
import { useBundle } from '@amzn/react-arb-tools';

const getValueFromEvent = (val: any) => {
  if (Array.isArray(val)) {
    return val.reduce((acc, v) => {
      const lowerCased = v.toLowerCase();
      if (emailRegex.test(lowerCased)) {
        acc.push(lowerCased);
      } else {
        void message.error(`${v} is not a valid email`);
      }
      return acc;
    }, []);
  } else {
    return val;
  }
};

export type EmailsProps = {
  form: FormInstance;
  label: string;
  disabled?: boolean;
  readOnly?: boolean;
  name: string;
  maxTagCount?: number;
  $itemSize?: CssSize;
};

const Emails = ({
  form,
  label,
  disabled,
  readOnly,
  name,
  $itemSize,
  maxTagCount = 10,
}: EmailsProps) => {
  const [emailsBundle] = useBundle('components.Emails');
  return (
    <FormItem
      $itemSize={$itemSize}
      label={label}
      name={name}
      rules={[{ required: false, message: ' ' }]}
      $readOnly={readOnly}
    >
      <Select
        mode="tags"
        maxTagCount={maxTagCount}
        disabled={disabled}
        notFoundContent={safeGetMessage(emailsBundle, 'not_found_content')}
        tokenSeparators={[',', ' ', '/']}
      />
    </FormItem>
  );
};

export default Emails;
